<template>
  <div class="box">
    <div class="top">
      <div class="logo clerfix">
        <img class="fl" src="../assets/10@2x.png" alt width="58px" />
        <div class="shu fl"></div>
        <div class="fl word">复星高照</div>
      </div>
      <p class="content">
        上海复爱信息科技有限公司致力于用科技手段整合优质商户资源、
        改善用户体验。公司致力于打造一站式本地服务综合平台，整合优质商家及服务，为用户提供更多线上消费选择。
      </p>
      <img class="phone" src="../assets/4@2x.png" alt width="400" />
    </div>
    <div class="fosun">
      <img src="../assets/11@2x.png" alt width="130px" />
      <span>联盟</span>
    </div>
    <ul class="imgList clearfix">
      <li>
        <img src="../assets/1@2x.png" alt width="266px" />
      </li>
      <li>
        <img src="../assets/lm@2x.png" alt width="266px" />
      </li>
      <li>
        <img src="../assets/shl@2x.png" alt width="266px" />
      </li>
      <li class="last">
        <img src="../assets/dslr@2x.png" alt width="266px" />
      </li>
      <li>
        <img src="../assets/nanxiang@2x.png" alt width="266px" />
      </li>
      <li>
        <img src="../assets/yuyuan@2x.png" alt width="266px" />
      </li>
      <li>
        <img src="../assets/qly@2x.png" alt width="267px" />
      </li>
      <li class="last">
        <img src="../assets/wt@2x.png" alt width="267px" />
      </li>
    </ul>
    <div class="mainShow">
      <p>主界面展示</p>
      <div class="flex">
        <div class="flexItem">
          <i class="circle"></i>
        </div>
        <div class="flexItem">
          <i class="circle"></i>
        </div>
        <div class="flexItem">
          <i class="circle"></i>
        </div>
      </div>
      <img class="phone" src="../assets/8@2x.png" alt width="1250px" />
    </div>
    <div class="footer">
      <div class="flexItem">
        <img src="../assets/5@2x.png" alt width="110px" />
        <p class="title">公司名称</p>
        <p class="line"></p>
        <p class="note">上海复爱信息科技有限公司</p>
      </div>
      <div class="flexItem">
        <img src="../assets/icp@2x.png" alt width="110px" />
        <p class="title">ICP备案信息</p>
        <p class="line"></p>
        <p class="note">沪ICP备15049270号-1</p>
      </div>
      <div class="flexItem">
        <img src="../assets/6@2x.png" alt width="110px" />
        <p class="title">公司地址</p>
        <p class="line"></p>
        <p class="note">上海市黄浦区复兴东路2号1006室</p>
      </div>
      <div class="flexItem">
        <img src="../assets/7@2x.png" alt width="110px" />
        <p class="title">客服中心</p>
        <p class="line"></p>
        <p class="note">0571-26219616</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "home",
  data() {
    return {};
  },
  methods: {}
};
</script>
<style scoped lang="scss">
.top {
  position: relative;
  background: url("../assets/9@2x.png") 0 0 no-repeat;
  background-size: 100% 100%;
  padding: 45px 0;
  .logo {
    margin-left: 20%;
    .shu {
      width: 1px;
      height: 38px;
      background: #ffffff;
      margin: 0 30px;
      position: relative;
      top: 10px;
    }
    .word {
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 56px;
    }
  }
  .content {
    width: 30%;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(255, 255, 255, 1);
    text-align: left;
    position: absolute;
    top: 200px;
    left: 20%;
    line-height: 36px;
  }
  .phone {
    margin-top: 5%;
    margin-bottom: 5%;
  }
}
.fosun {
  span {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    margin-left: 12px;
    position: relative;
    top: -3px;
  }
}
.imgList {
  width: 1210px;
  margin: 0 auto;
  li {
    width: 266px;
    height: 114px;
    float: left;
    margin-right: 46px;
    margin-top: 70px;
    &.last {
      margin-right: 0;
    }
  }
}
.mainShow {
  height: 944px;
  background: rgba(255, 240, 240, 1);
  margin-top: 150px;
  p {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    position: relative;
    top: 85px;
  }
  img {
    margin-top: 170px;
  }
  .flex {
    display: flex;
    width: 1310px;
    margin:0 auto;
    position: relative;
    top:150px;
    .flexItem {
      flex: 1;
      .circle {
        width: 16px;
        height: 16px;
        background: #e33832;
        border-radius: 50%;
        display: inline-block;
      }
    }
  }
}
.footer {
  width: 1250px;
  display: flex;
  margin: 120px auto;
  .title {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    font-size: 20px;
    margin-top: 14px;
    margin-bottom: 17px;
  }
  div.flexItem {
    flex: 1;
    .line {
      height: 1px;
      background: #ff5502;
      margin: 10px auto;
      width: 70%;
    }
    .note {
      font-size: 16px;
    }
  }
}
</style>
